export default "__VITE_ASSET__DMd7EED0__"